var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPatientCareLabIcon = function SvgPatientCareLabIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.52 17.039h4.569a.52.52 0 0 0 0-1.039h-4.57a.52.52 0 1 0 0 1.039z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.604 7H10.776a.52.52 0 0 0-.52.52v11.337H7.52a.52.52 0 0 0-.519.52v1.204a3.04 3.04 0 0 0 3.037 3.036h10.05a3.04 3.04 0 0 0 3.036-3.036V7.519A.52.52 0 0 0 22.604 7zM10.037 22.579a2 2 0 0 1-1.998-1.998v-.685h9.011v.685c0 .764.284 1.463.752 1.998h-7.765zm12.048-1.998a2 2 0 0 1-1.998 1.998 2 2 0 0 1-1.998-1.998v-1.204a.52.52 0 0 0-.52-.52h-6.274V8.04h10.79V20.58z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.47 11.563h-1.563V10h-1.875v1.563H14.47v1.874h1.562V15h1.875v-1.563h1.563z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPatientCareLabIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/patient-care-lab-icon.b5ee22e8a4f658a602568b1716372e02.svg";